// This file is generated by a script and should not be modified directly.
const markdown: string =
  "- `null` si et seulement si aucun diplôme CFD correspondant à la fiche RNCP (`identifiant.rncp`) n'est connu.\n- Lorsque le code est `null`, toutes les informations issues de la base centrale des nomenclatures (BCN) seront `null`\n"
export default markdown
